import React from 'react'
import PropTypes from 'prop-types'
import { useGroupTypeSearch } from '../../../../api/groups'
import LevelTags from '../LevelTags'
import { getGroupTypesQuery, tagTypesQueryOptions } from '../LevelTags/helpers'
import { CLIENTS_MEMBER_LEVEL_ID, CLIENT_BILLING_FORM_NAMES } from './helpers'

const CLIENT_TAGS = CLIENT_BILLING_FORM_NAMES.tags
const query = getGroupTypesQuery({ memberLevelTypeId: CLIENTS_MEMBER_LEVEL_ID })

const ClientDetailsTags = ({ editMode }) => {
  const { data: groupOptions, isLoading } = useGroupTypeSearch(
    query,
    tagTypesQueryOptions
  )
  return (
    <LevelTags
      name={CLIENT_TAGS}
      editMode={editMode}
      isLoading={isLoading}
      tagOptions={groupOptions}
    />
  )
}

ClientDetailsTags.propTypes = {
  editMode: PropTypes.bool
}

ClientDetailsTags.defaultProps = {
  editMode: false
}

export default ClientDetailsTags
